import { lazy } from 'react';
import { authRoles } from 'app/auth';

const DataAppConfig = {
	settings: {
		layout: {}
	},
	auth: [...authRoles.warehouseMan, ...authRoles.warehouseAssistant],
	routes: [
		{
			exact: true,
			path: '/apps/warehouses-order-requests',
			component: lazy(() => import('./list/Datas'))
		},
		{
			exact: true,
			path: '/apps/warehouses-order-requests/:dataID',
			component: lazy(() => import('./single/Data'))
		}
	]
};

export default DataAppConfig;
